//import router from 'src/routes/routes'
import axios from 'axios'

export default {
    namespaced: true,
    state: {
        builderData: null,
        builtFrame: null,
        builtFrameData: null,
        frameBuilderSessionId: null,
        builderFilters: {moulding:{},mat:{},fillet:{}}
    },
    getters: {
        getBuiltFilters(state){
            return state.builderFilters
        },
        getBuiltFrame(state){
            return state.builtFrame
        },
        getFrameBuilderSessionId(state) {
            return localStorage.getItem('frameBuilderSessionId') === null ? state.frameBuilderSessionId : JSON.parse(localStorage.getItem('frameBuilderSessionId'))
        },
    },
    actions: {
        initBuilderId({commit,state, getters}){
            if(!state.frameBuilderSessionId){
                let hasS = getters.getFrameBuilderSessionId
                if(!hasS){
                    //create new id and set
                    let newBuilderId = (new Date().getTime() * Math.random() * 100000)
                    commit('setBuilderId',newBuilderId)
                }
            }
        },
        buildFilters({commit}){
            return new Promise((resolve, reject) => {
                let data = {}
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/framebuilder/buildFilters',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data
                }
                axios(config)
                    .then(response => {
                        commit('setBuilderFilters',response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        buildFrame({commit},{options}){
            //used for Admin creation
            return new Promise((resolve, reject) => {
                let data = { ...options }
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/framebuilder/buildFrame',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                }
                axios(config)
                    .then(response => {
                        commit('setBuiltFrame',response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        hasFrameImg(_,Code){
            //used for Admin creation
            return new Promise((resolve, reject) => {
                let data = { Code }
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/framebuilder/getImageInfo',
                    headers: {
                        'Authorization': 'Bearer ' + this.getters['userAccess/accessToken']
                    },
                    data: data
                }
                axios(config)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        createFrame({commit},{imgData, options}){
            //used for Admin creation
            return new Promise((resolve, reject) => {
                let data = { imgData, ...options }
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/framebuilder/adminframebuilder',
                    headers: {
                        'Authorization': 'Bearer ' + this.getters['userAccess/accessToken']
                    },
                    data: data
                }
                axios(config)
                    .then(response => {
                        commit('setBuilderData',response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
    },
    mutations: {
        setBuilderId(state, id){
            localStorage.setItem('frameBuilderSessionId', id)
            state.frameBuilderSessionId = id
        },
        setBuilderData(state, imgData){
            state.builderData = imgData
        },
        setBuiltFrame(state, imgData){
            state.builtFrame = imgData.outFile
            state.builtFrameData = imgData
        },
        setBuilderFilters(state, filters){
            state.builderFilters = filters
        },
    }
}